import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';


export function* getRejectDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('reject-reasons?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('reject-reasons'));
        }
        yield put({
            type: actions.REJECT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.REJECT_DETAILS_FAILURE });
        return error;
    }
}

export function* getTaxType(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.TAX_TYPE_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        yield put({ type: actions.TAX_TYPE_FAILURE });
        return error;
    }
}

export function* getWorkflow(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.WORKFLOW_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.WORKFLOW_FAILURE });
        return error;
    }
}

export function* getFrequency(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.FREQUENCY_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.FREQUENCY_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_SETUP_SUCCESS,
    });
}


export default function* younoteAdminSetupSaga() {
    yield all([
        takeEvery(actions.REJECT_DETAILS_START, getRejectDetails),
        takeEvery(actions.TAX_TYPE_START, getTaxType),
        takeEvery(actions.WORKFLOW_START, getWorkflow),
        takeEvery(actions.FREQUENCY_START, getFrequency),
        takeEvery(actions.CLEAR_SETUP_START, getClearDetails)
    ]);
}